module.exports = __webpack_public_path__ + "img/bild_present_past.689553ab.jpg";